import mutations from './organizationMutations'
import actions from './organizationActions'
import state from './organizationState'
import getters from './organizationGetters'

export default {
  state,
  actions,
  getters,
  mutations,
}
